var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Sponsors")]),_c('section',{staticClass:"contentGrid"},_vm._l((_vm.sponsors),function(sponsor){return _c('Sponsor',{key:sponsor.name,attrs:{"sponsor":sponsor}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }